import { render, staticRenderFns } from "./PointsProduct.vue?vue&type=template&id=79f6a733&scoped=true"
import script from "./PointsProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointsProduct.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PointsProduct.vue?vue&type=style&index=0&id=79f6a733&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6a733",
  null
  
)

export default component.exports